import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import PrimaryButton, { TransparentBgButton } from 'components/Shared/Button'

export default function SpecialAdConfirmModal({ onCancel, onConfirm, loading, specialAdCategory }) {
  const { t } = useTranslation()

  return (
    <div className="special-ad-confirm-modal">
      <h3>{t('Simulation.form.specialAdConfirm.title')}</h3>

      <p>
        {specialAdCategory
          ? t('Simulation.form.specialAdConfirm.body', {
            specialAdCategory: Array.isArray(specialAdCategory)
              ? t('Simulation.form.specialAdCategories.' + specialAdCategory[0])
              : t('Simulation.form.specialAdCategories.' + specialAdCategory),
          })
          : t('Simulation.form.specialAdConfirm.body', { specialAdCategory: '' })
        }
      </p>

      <div className="button-wrap">
        <TransparentBgButton text={t('Simulation.form.specialAdConfirm.btnCancel')} onClick={onCancel} color="navy" fullWidth={false} disabled={loading}/>

        <PrimaryButton text={t('Simulation.form.specialAdConfirm.btnConfirm')} onClick={onConfirm} fullWidth={false} disabled={loading} />
      </div>
    </div>
  )
}

SpecialAdConfirmModal.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
}